import axios from "axios";
import { POST_SUBMITTED } from "../../../config/realstar-api-config";

export const post_submittedRecords = async (data , transactionID) => {
    const URL = `${POST_SUBMITTED}`;

    const authKey = process.env.REACT_APP_REALSTAR_AUTH_KEY; 
    const rs_code = process.env.REACT_APP_REALSTAR_RS_CODE; 

    // Convert formData to a URLSearchParams object
    const urlEncodedData = new URLSearchParams();
    urlEncodedData.append('trxno', transactionID); // Append the file
    urlEncodedData.append('content', JSON.stringify(data)); // Append additional parameters
    urlEncodedData.append('userid', "42"); // Append additional parameters

    const options = {
        method: 'POST',
        url: URL,
        headers: {
          'Auth-Key': authKey,
          'RS-Code': rs_code,
          'Content-Type': "application/x-www-form-urlencoded"
        },
        data: urlEncodedData // Send URL-encoded data
    };

    try {
        const response = await axios(options);

        if (response.status === 200) {
            return response?.data;
        } else {
            return response?.data;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};